<template>
<el-steps v-if="availableWidth < breakPointSM && $route.name !== 'formular'"
  :active="$route.name - 1"
  finish-status="success"
  process-status="finish"
  class="steps">
  <el-step v-for="(item, index) in items"
    :title="$route.name === index + 1 ? $t('ibe.tab' + (index + 1)) : ''"
    :key="item.url">
  </el-step>
</el-steps>
<el-row v-else-if="$route.name !== 'formular'"
  type="flex"
  justify="center"
  :gutter="10"
  class="navi-row"
  :body-style="{ padding: '0px' }">
  <template v-for="(item, index) in items">
    <el-col
      :key="'tab_' + index">
      <router-link
        :to="item.url"
        tag="div">
        <el-button
          type="primary"
          :disabled="($route.name <= index && !bookFinished && !enableAllTabs)">
          {{ $route.name === index + 1 ? availableWidth > breakPointXS ? $t('ibe.tab' + (index + 1)) : index + 1 + '.' : availableWidth > breakPointSM ? $t('ibe.tab' + (index + 1)) : index + 1 + '.' }}
        </el-button>
      </router-link>
    </el-col>
  </template>
</el-row>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BookingNavi',
  data () {
    return {
      breakPointSM: 650,
      breakPointXS: 360,
      enableAllTabs: !!(window.initData.debugMode & (1 << 1)),
      items: [
        { url: '/step1' },
        { url: '/step2' },
        { url: '/step3' },
        { url: '/step4' },
        { url: '/step5' }
      ]
    }
  },
  computed: {
    ...mapGetters('booking', [
      'availableWidth',
      'bookFinished'
    ])
  }
}
</script>
